import { render, staticRenderFns } from "./ScienceAdd.vue?vue&type=template&id=4612ba1d"
import script from "./ScienceAdd.vue?vue&type=script&lang=js"
export * from "./ScienceAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports